import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { eDiscoveryDocumentSearchSpec, eDiscoveryRequestSearchSpec, eDiscoveryRequest } from "../models/eDiscovery.model";
import { OnBaseDocumentDetails } from '../../common/models/onBaseIntegrationAndMapping.model';


@Injectable({
  providedIn: 'root'
})
export class EDiscoveryService {

    private readonly BASE_URL: string = "/api/eDiscovery";

    constructor(private _http: HttpClient) { }

    createRequest(request: eDiscoveryRequest): Observable<eDiscoveryRequest> {
        return this._http.post<eDiscoveryRequest>(`${this.BASE_URL}/createRequest`, request);
    }

    searchDocuments(spec: eDiscoveryDocumentSearchSpec): Observable<OnBaseDocumentDetails[]> {  
        return this._http.post<OnBaseDocumentDetails[]>(`${this.BASE_URL}/searchDocuments`, spec);
    }

    searchRequests(spec: eDiscoveryRequestSearchSpec): Observable<eDiscoveryRequest[]> {
        return this._http.post<eDiscoveryRequest[]>(`${this.BASE_URL}/searchRequests`, spec);
    }

    simulateEDiscoveryTask(): Observable<string> {
        return this._http.get<string>(`${this.BASE_URL}/generateDocuments`);
    }

    testGenerateEDiscovery(requestId: string): Observable<string> {      
        return this._http.post<string>(`${this.BASE_URL}/testGenerate/`, { requestId: requestId });
    }

}
